import React, { FC, useContext } from "react";
import ConfigurationContext from "../../../infrastructure/context/configuration/configuration.context";
import {
  CouponResponseCode,
  CustomPropertyKeys,
  FeatureFlagValues,
  TranslationKeys,
} from "../../../infrastructure/const";
import EanNumber from "./ean-number";
import ReferralCode from "./referral-code";
import VatExemptCheckbox from "./vat-exempt-checkbox";
import TranslationManager from "../../../infrastructure/translation-manager";
import TranslationsContext from "../../../infrastructure/context/translations/translations-context";
import PromoCode from "./promo-code";

type Props = {
  properties: Record<string, any>;
  handlePropertyUpdate: (
    key: string,
    value: string | boolean,
    skipCartUpdate: boolean,
    successMessage?: string,
    cancelMessage?: string
  ) => void;
  couponResponseCode: keyof typeof CouponResponseCode;
};

const OrderSummary: FC<Props> = ({
  properties,
  handlePropertyUpdate,
  couponResponseCode,
}) => {
  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  const { getFeatureFlagValue } = useContext(ConfigurationContext);

  const orderSummaryType = getFeatureFlagValue("orderSummaryType");

  if (orderSummaryType === FeatureFlagValues.OrderSummary.UK) {
    return (
      <>
        <VatExemptCheckbox
          properties={properties}
          onUpdate={(isChecked: boolean) =>
            handlePropertyUpdate(CustomPropertyKeys.UK.VatExempt, isChecked, false)
          }
        />
        <ReferralCode
          properties={properties}
          onUpdate={(value: string) =>
            handlePropertyUpdate(
              CustomPropertyKeys.UK.ReferralCode,
              value,
              false,
              translationManager.getTranslation(
                TranslationKeys.UK.CART_REFERRALCODE_APPLIED
              ),
              translationManager.getTranslation(
                TranslationKeys.UK.CART_REFERRALCODE_CANCELED
              )
            )
          }
        />
      </>
    );
  }

  if (orderSummaryType === FeatureFlagValues.OrderSummary.DK) {
    return (
      <>
        <EanNumber
          properties={properties}
          onUpdate={(value: string) =>
            handlePropertyUpdate(
              CustomPropertyKeys.DK.EANNumber,
              value,
              false,
              translationManager.getTranslation(
                TranslationKeys.DK.EAN_NUMBER_APPLIED
              ),
              translationManager.getTranslation(
                TranslationKeys.DK.EAN_NUMBER_CANCELED
              )
            )
          }
        />
        <PromoCode
          couponResponseCode={couponResponseCode}
          properties={properties}
          onUpdate={(value: string) =>
            handlePropertyUpdate(CustomPropertyKeys.Global.PromoCode, value, false)
          }
        />
      </>
    );
  }

  return (
    <PromoCode
      couponResponseCode={couponResponseCode}
      properties={properties}
      onUpdate={(value: string) =>
        handlePropertyUpdate(CustomPropertyKeys.Global.PromoCode, value, false)
      }
    />
  );
};

export default OrderSummary;
